module.exports = __webpack_public_path__ + "components/rewards/intersport/static/logo-f60c975bf2a92c64c2e88e8bf9a030e9.jpg";